<script setup>
import {computed, onMounted, reactive, ref, watch} from "vue";
import moment from "moment/moment";
import axios from "axios";
import CompletedInspectionFilter from "./CompletedInspectionFilter.vue";
import TableRowDataLoader from "@/components/shared/loader/TableRowDataLoader.vue";

const props = defineProps(["tasks"]);

const pagination = ref(null);
const offset = ref(3);
const trees = ref(null);
const loading = ref(true);

const sortBy = ref("created_at");
const sortAsc = ref(true);
const inspections = ref([]);
const attachments = ref({});
const groupByDate = ref(false);
const groupByUser = ref(false);
const updatedBetween = ref(null);
const createdBetween = ref(null);
const selectedFilters = ref({});
const hideThings = ref(true);
const filter = reactive({
    trees_species_id: null,
    trees_status_id: null,
    trees_ule_id: null,
    trees_risk_id: null,
    trees_age_id: null,
    trees_health_id: null,
    trees_height_id: null,
    trees_structure_id: null,
    trees_canopy_id: null,
    trees_circumference_id: null,
    trees_dbh_id: null,
    work_tasks_done: null,
    work_tasks_required: null,
    work_mutate: null,
    works_id: null,
    trees_tag_id: null,
    equipment_id: null,
    storm_event: null,
});

const trees_maintenance = reactive({
    status: null,
    user_id: null,
    work_tasks_done: null,
});
const trees_inspection = reactive({
    work_complete: null,
    user_id: null,
    work_tasks: null,
});

onMounted(() => {
    getCompletedInspections();
});

const getCompletedInspections = () => {
    axios
        .post("api/reporting/inspections?" + queryString() + "&users_only=1" + "&getMap=nomap")
        .then((response) => {
            pagination.value = response.data.trees;
            inspections.value = response.data.trees.data;
            trees.value = response.data.map_trees;
            loading.value = false;
        })
        .catch((error) => {
            console.log(error);
        });
};

const queryString = (getMapData = true) => {
    var q = "";

    let keys = Object.keys(filter);
    for (let key of keys) {
        if (filter[key]) {
            var val = "";
            if (Array.isArray(filter[key])) {
                filter[key].forEach((e, i) => {
                    if (i !== 0) {
                        val = val + ",";
                    }
                    val = val + e;
                });
            } else {
                val = filter[key];
            }
            q = q + "filter[" + key + "]=" + val + "&";
        }
    }

    if (createdBetween.value &&createdBetween.value.start && createdBetween.value.end) {
        q =
            q +
            "filter[created_between]=" +
            moment(createdBetween.value.start).format("YYYY-MM-DD") +
            "," +
            moment(createdBetween.value.end).format("YYYY-MM-DD") +
            "&";
    }

    let inspections = Object.keys(trees_inspection);
    for (let key of inspections) {
        if (trees_inspection[key]) {
            var val = "";
            trees_inspection[key].forEach((e, i) => {
                if (i !== 0) {
                    val = val + ",";
                }
                val = val + e;
            });
            q = q + "filter[trees_inspection." + key + "]=" + val + "&";
        }
    }

    // if(this.polygonWkt && getMapData) {
    //     q = q + "&area=" + this.polygonWkt;
    // }

    q =
        q +
        "&groupByDate=" +
        groupByDate.value +
        "&groupByUser=" +
        groupByUser.value +
        "&";

    return q;
};

const handleEmitFilter = (filters) => {
    selectedFilters.value = filters;
};

watch(selectedFilters, () => {
    createdBetween.value = selectedFilters.value["createdBetween"];
    filter.work_mutate = selectedFilters.value["works"];
    getCompletedInspections();
});
//TODO: Refactor Change page and Change page url
const changePage = (page) => {
    if (loading.value) {
        return;
    }
    loading.value = true;
    axios
        .post(
            "/api/reporting/works?" +
            queryString(false) +
            "page=" +
            page +
            "&users_only=1" +
            "&getMap=nomap"
        )
        .then((response) => {
            pagination.value = response.data.trees;
            inspections.value = response.data.trees.data;
            trees.value = response.data.map_trees;
            loading.value = false;
        })
        .catch((error) => {
            console.log(error);
        });
};

const changePageUrl = (url) => {
    if (loading.value) {
        return;
    }
    loading.value = true;
    axios
        .get(url)
        .then((response) => {
            pagination.value = response.data.trees;
            inspections.value = response.data.trees.data;
            trees.value = response.data.map_trees;
            loading.value = false;
        })
        .catch((error) => {
            console.log(error);
        });
};

const sortArray = (array) => {
    if (sortBy.value === "created_at") {
        if (sortAsc.value) {
            return array.sort(
                (a, b) => new Date(b.created_at) - new Date(a.created_at)
            );
        }
        if (!sortAsc.value) {
            return array.sort(
                (b, a) => new Date(b.created_at) - new Date(a.created_at)
            );
        }
    }
};

const getStatus = (s) => {
    if (s === 1) {
        return "Planting Location";
    } else if (s === 2) {
        return "Active";
    } else if (s === 3) {
        return "Stump";
    } else if (s === 4) {
        return "Removed";
    } else {
        return "NA";
    }
};
const dateTime = (date) => {
    if (moment(date).isValid()) {
        return moment(date).format("DD/MM/YY, h:mm a");
    } else {
        return "-";
    }
};

const formatWorkTask = (arrayString) => {
    if (!arrayString) {
        return [];
    }
    return arrayString.substring(1, arrayString.length - 1).split(",");
};
const getWorkTask = (taskId) => {
    if (parseInt(taskId)) {
        var length = props.tasks.length;
        for (var i = 0; i < length; i++) {
            if (props.tasks[i].id === parseInt(taskId)) {
                return props.tasks[i].task;
            }
        }
    }
};

const pages = computed(() => {
    if (!pagination.value.to) {
        return null;
    }
    let from = pagination.value.current_page - offset.value;
    if (from < 1) {
        from = 1;
    }
    let to = from + offset.value * 2;
    if (to >= pagination.value.last_page) {
        to = pagination.value.last_page;
    }
    let pages = [];
    for (let page = from; page <= to; page++) {
        pages.push(page);
    }
    return pages;
});
</script>
<template>
    <div class="completedInspectionPage flex-col">
        <div class="flex">
            <div class="w-full">
                <p class="my-3 text-xl text-slate-600">
                    Completed Inspections ({{ pagination?.total || 0 }})
                </p>
                <p class="my-3 text-md text-slate-500">
                    Inspections that have been completed including notes created during
                    inspection
                </p>
            </div>
        </div>
        <div class="inspectionCompleteFilter w-full">
            <CompletedInspectionFilter
                :tasks="props.tasks"
                @emit-filter="handleEmitFilter"
            />
        </div>
        <div
            v-if="inspections"
            class="ftree-table striped hovered main-first-cell w-full overflow-x-auto pt-4"
        >
            <div v-if="inspections.length" class="thead">
                <div class="tr py-2 thead">
                    <div class="td items-center w-1/2 lg:w-1/5">Inspection ID</div>
                    <div class="td items-center w-1/2 lg:w-1/5">Inspected By</div>
                    <div class="td items-center w-1/2 lg:w-1/5">Work Required</div>
                    <div class="td items-center w-1/2 lg:w-1/5">Tree</div>
                    <div
                        @click.prevent="
              sortBy = 'created_at';
              sortAsc = !sortAsc;
              sortArray();
            "
                        class="td items-center w-1/2 lg:w-1/5 cursor-pointer"
                    >
                        Risk
                    </div>
                </div>
            </div>
            <p v-if="!inspections.length" class="text-slate-600 mt-3 mb-2">
                no completed inspections.
            </p>
            <div v-else class="tbody text-left text-slate-700 pb-8">
                <div
                    class="w-full flex flex-row tr"
                    v-for="inspection in pagination.data"
                    :key="inspection.id"
                >
                    <div class="py-4 border-b border-slate-200 w-1/2 lg:w-1/5">
                        <div class="items-center">
                            <div class="text-sm leading-5 font-medium text-slate-900">
                                Inspection ID: {{ inspection.id }}
                            </div>
                            <a
                                :href="'/map?treeId=' + inspection.tree_id"
                                target="_blank"
                                class="text-sm leading-5 text-blue-500 hover:text-blue-700"
                            >Tree ID: {{ inspection.tree_id }}</a
                            >
                        </div>
                    </div>
                    <div class="py-4 border-b border-slate-200 w-1/2 lg:w-1/5">
                        <div class="text-sm leading-5 text-slate-900">
                            {{
                                inspection.completed_by ? inspection.completed_by.name : "NA"
                            }}
                        </div>
                        <div class="text-sm leading-5 text-slate-500">
                            {{ dateTime(inspection.updated_at) }}
                        </div>
                    </div>
                    <div class="py-4 border-b border-slate-200 w-1/2 lg:w-1/5">
                        <div class="flex flex-wrap max-w-1/2">
              <span
                  v-if="inspection.crm"
                  class="bg-red-400 text-red-100 text-xs rounded-full px-3 py-1 font-semibold mr-1 my-1"
              >{{ inspection.crm.crm_id }}</span
              >
                            <template
                                v-for="(task, index) in formatWorkTask(inspection.work_tasks)"
                                :key="index"
                            >
                <span
                    v-if="getWorkTask(task)"
                    class="bg-green-200 text-green-700 text-xs rounded-full px-3 py-1 font-semibold mr-1 my-1"
                >{{ getWorkTask(task) }}</span
                >
                            </template>
                        </div>
                    </div>
                    <div class="py-4 border-b border-slate-200 w-1/2 lg:w-1/5">
                        <div class="text-sm leading-5 text-slate-900">
                            {{ inspection.tree ? inspection.tree.genus : "NA" }}
                            ({{ inspection.tree ? inspection.tree.common_name : "NA" }})
                        </div>
                        <div class="text-sm leading-5 text-slate-500">
              <span class="italic">{{
                      inspection.tree ? inspection.tree.species : "NA"
                  }}</span>
                            {{ inspection.tree ? inspection.tree.family : "NA" }}
                        </div>
                    </div>
                    <div
                        class="py-4 border-b border-slate-200 text-sm leading-5 text-slate-500 w-1/2 lg:w-1/5"
                    >
                        <div
                            v-if="inspection.tree && inspection.tree.trees_status_id"
                            class="mb-2"
                        >
              <span
                  v-if="inspection.tree.trees_status_id === 1"
                  class="bg-blue-200 text-blue-700 text-xs rounded-full px-3 py-1 font-semibold"
              >{{ getStatus(inspection.tree.trees_status_id) }}</span
              >
                            <span
                                v-if="inspection.tree.trees_status_id === 2"
                                class="bg-green-200 text-green-700 text-xs rounded-full px-3 py-1 font-semibold"
                            >{{ getStatus(inspection.tree.trees_status_id) }}</span
                            >
                            <span
                                v-if="inspection.tree.trees_status_id === 3"
                                class="bg-slate-100 text-slate-700 text-xs rounded-full px-3 py-1 font-semibold"
                            >{{ getStatus(inspection.tree.trees_status_id) }}</span
                            >
                            <span
                                v-if="inspection.tree.trees_status_id === 4"
                                class="bg-red-300 text-red-700 text-xs rounded-full px-3 py-1 font-semibold"
                            >{{ getStatus(inspection.tree.trees_status_id) }}</span
                            >
                        </div>
                        <div v-if="inspection.tree && inspection.tree.trees_risk_id">
              <span
                  v-if="inspection.tree.trees_risk_id === 1"
                  class="bg-green-500 text-white text-xs rounded-full px-3 py-1"
              >Low Risk</span
              >
                            <span
                                v-if="inspection.tree.trees_risk_id === 2"
                                class="bg-orange-500 text-white text-xs rounded-full px-3 py-1"
                            >Moderate Risk</span
                            >
                            <span
                                v-if="inspection.tree.trees_risk_id === 3"
                                class="bg-red-500 text-white text-xs rounded-full px-3 py-1"
                            >High Risk</span
                            >
                            <span
                                v-if="inspection.tree.trees_risk_id === 4"
                                class="bg-red-700 text-white text-xs rounded-full px-3 py-1"
                            >Extreme Risk</span
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <p v-else class="text-slate-600 mt-3 mb-2">Fetching Data....</p>

        <div
            v-if="pagination && pagination.last_page !== 1"
            class="bg-white px-4 py-3 flex items-center justify-between border-t border-slate-200 sm:px-6"
        >
            <div class="flex-1 flex justify-between sm:hidden">
                <a
                    href="#"
                    @click.stop="changePageUrl(pagination.prev_page_url)"
                    class="relative inline-flex items-center px-4 py-2 border border-slate-300 text-sm leading-5 font-medium rounded-md text-slate-700 bg-white hover:text-slate-500 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 active:bg-slate-100 active:text-slate-700 transition ease-in-out duration-150"
                >Previous</a
                >
                <a
                    href="#"
                    @click.stop="changePageUrl(pagination.next_page_url)"
                    class="ml-3 relative inline-flex items-center px-4 py-2 border border-slate-300 text-sm leading-5 font-medium rounded-md text-slate-700 bg-white hover:text-slate-500 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 active:bg-slate-100 active:text-slate-700 transition ease-in-out duration-150"
                >Next</a
                >
            </div>
            <div class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
                <div>
                    <p class="text-sm leading-5 text-slate-700">
                        Showing
                        <span class="font-medium">{{ pagination.current_page }}</span>
                        to
                        <span class="font-medium">{{ pagination.last_page }}</span>
                        of
                        <span class="font-medium">{{ pagination.total }}</span>
                        results
                    </p>
                </div>
                <div>
          <span class="relative z-0 inline-flex shadow-sm">
            <button
                type="button"
                @click.stop="changePageUrl(pagination.prev_page_url)"
                class="relative inline-flex items-center px-2 py-2 rounded-l-md border border-slate-300 bg-white text-sm leading-5 font-medium text-slate-500 hover:text-slate-400 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-slate-100 active:text-slate-500 transition ease-in-out duration-150"
            >
              <svg class="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                <path
                    fill-rule="evenodd"
                    d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                    clip-rule="evenodd"
                />
              </svg>
            </button>

            <button
                v-for="page in pages"
                :key="page"
                @click.stop="changePage(page)"
                type="button"
                :class="
                page === pagination.current_page
                  ? 'text-blue-700 hover:text-blue-500 bg-slate-100'
                  : 'bg-white text-slate-700 hover:text-slate-500'
              "
                class="-ml-px relative inline-flex items-center px-4 py-2 border border-slate-300 text-sm leading-5 font-medium focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-slate-100 active:text-slate-700 transition ease-in-out duration-150"
            >
              {{ page }}
            </button>

            <span
                class="-ml-px relative inline-flex items-center px-4 py-2 border border-slate-300 bg-white text-sm leading-5 font-medium text-slate-700"
            >...</span
            >

            <button
                type="button"
                @click.stop="changePageUrl(pagination.last_page_url)"
                :class="
                pagination.last_page === pagination.current_page
                  ? 'text-blue-700 hover:text-blue-500 bg-slate-100'
                  : 'bg-white text-slate-700 hover:text-slate-500'
              "
                class="-ml-px relative inline-flex items-center px-4 py-2 border border-slate-300 bg-white text-sm leading-5 font-medium text-slate-700 hover:text-slate-500 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-slate-100 active:text-slate-700 transition ease-in-out duration-150"
            >
              {{ pagination.last_page }}
            </button>

            <button
                type="button"
                @click.stop="changePageUrl(pagination.next_page_url)"
                class="-ml-px relative inline-flex items-center px-2 py-2 rounded-r-md border border-slate-300 bg-white text-sm leading-5 font-medium text-slate-500 hover:text-slate-400 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-slate-100 active:text-slate-500 transition ease-in-out duration-150"
            >
              <svg class="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                <path
                    fill-rule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clip-rule="evenodd"
                />
              </svg>
            </button>
          </span>
                </div>
            </div>
        </div>
        <div class="w-full grid place-items-center">
            <TableRowDataLoader :loading="loading"/>
        </div>
    </div>
</template>
<style scoped>
.td-block-wrap {
    display: block !important;
}

.tbody .tr {
    display: -webkit-inline-box;
}

.rotate-180 {
    transform: rotate(180deg);
}
</style>
